module.exports = __webpack_public_path__ + "img/img-6.200d76b3.png";